import { render, staticRenderFns } from "./updateCallDebtorPhone.vue?vue&type=template&id=58f2ebf3&"
import script from "./updateCallDebtorPhone.vue?vue&type=script&lang=js&"
export * from "./updateCallDebtorPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports